// import PersonalProfile from './ProfilePage/ProfilePage';
import ProfilePage from './UserProfile/ProfilePage';
export default ProfilePage;
